import React, { useState } from "react";
import { Form } from "react-bootstrap";
import {
  FaDiscord,
  FaEnvelope,
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaMedium,
  FaTiktok,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { BsFillInfoCircleFill } from "react-icons/bs";
import { CiCircleChevDown, CiCircleChevUp } from "react-icons/ci";
import { useMutation } from "react-query";
import { useSubscribeUser } from "../hooks/useSubscribeUser";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import { useCookies } from "react-cookie";

const socialMediaLinks = [
  {
    id: 1,
    icon: <FaFacebook size={"22"} />,
    alt: "Facebook Icon",
    url: "https://www.facebook.com/carre.ai2023",
  },
  {
    id: 2,
    icon: <FaTwitter size={"22"} />,
    alt: "Twitter Icon",
    url: "https://twitter.com/carre_ai",
  },
  {
    id: 4,
    icon: <FaEnvelope size={"22"} />,
    alt: "Email Icon",
    url: "mailto:info@carre.ai",
  },
  {
    id: 5,
    icon: <FaLinkedin size={"22"} />,
    alt: "LinkedIn Icon",
    url: "https://www.linkedin.com/company/98619422/admin/feed/posts/",
  },
  {
    id: 6,
    icon: <FaMedium size={"22"} />,
    alt: "Medium Icon",
    url: "https://medium.com/@carre.ai",
  },
  {
    id: 7,
    icon: <FaDiscord size={"22"} />,
    alt: "Discord Icon",
    url: "https://discord.com/invite/vrrkM3YD",
  },
];

const quickLinks = [
  {
    title: "370 NE 75th Street, Unit 126, Miami, Florida, United States 33138",
    url: "/",
  },
];

const aboutLinks = [
  { title: "About Us", url: "/aboutuspage" },
  { title: "Learn", url: "/helpcenter" },
  { title: "Marketplace", url: "/marketplace" },
  { title: "Terms of services", url: "/terms-of-service" },
  { title: "Privacy policy", url: "/privacy-policy" },
];

const Footer = () => {
  const [cookies, setCookies, removeCookie] = useCookies();
  const [showInformation, setShowInformation] = useState(true);
  const { mutate, isLoading } = useMutation(useSubscribeUser, {
    onSuccess: (data) => {
      toast.success("Successfully subscribed");
      if (process.env.REACT_APP_IS_PRODUCTION !== "false") {
        setCookies("event_id", uuidv4());
        // eslint-disable-next-line no-undef
        fbq(
          "track",
          "Lead",
          {},
          {
            event_id: cookies["event_id"],
            external_id: JSON.parse(localStorage.getItem("utmParams"))
              ?.external_id,
          }
        );
      }
    },
    onError: (error) => {
      toast.error(error?.response.data.error);
    },
  });

  const [isCheckboxError, setIsCheckboxError] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // eslint-disable-next-line no-undef
    const email = e.target.elements.email.value;
    const shouldReceiveMarketingEmails = e.target.elements.marketing.checked;
    subscribe(email, shouldReceiveMarketingEmails);
  };

  const subscribe = (email, shouldReceiveMarketingEmails) => {
    if (!shouldReceiveMarketingEmails) {
      setIsCheckboxError(true);
    } else {
      mutate(email);
      setIsCheckboxError(false);
    }
  };
  const toggleInformation = () => {
    setShowInformation(!showInformation);
  };
  return (
    <footer className="footer pt-5">
      <div
        className="container pt-md-2 pt-lg-3 pt-xl-4  rounded-4"
        style={{ backgroundColor: "#78aed2" }}
      >
        <div className="row pb-5 pt-sm-2 mb-lg-2 p-3">
          <div className="col-md-12 col-lg-3 pb-2 pb-lg-0 mb-4 mb-lg-0">
            <a
              href="/"
              className="navbar-brand py-0 mb-3 mb-lg-4"
              aria-label="Go to homepage"
            >
              <svg
                width={116}
                height={50}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 116 40"
              >
                <path
                  fill="#fff"
                  d="M17.58.827.83 17.531a2.817 2.817 0 0 0 0 3.991l16.75 16.704a2.836 2.836 0 0 0 4.003 0l16.75-16.704a2.816 2.816 0 0 0 0-3.99L21.583.826a2.836 2.836 0 0 0-4.001 0l-.001.001Z"
                />
                <path
                  fill="#3899da"
                  d="M23.963 28.93c-1.046-.35 -3.406-2.53-3.406-4.446-.26-6.443 2.29-6.618 2.29-11.424a9.887 9.887 0 0 0-3.323-7.36 9.875 9.875 0 0 0-3.303 7.4c0 4.79 2.533 4.95 2.292 11.423 0 1.904-2.36 4.094-3.406 4.444-1.047.35 1.909.868 3.23 0 0 0 .058 3.55 1.207 4.44 1.146-.89 1.207-4.44 1.207-4.44 1.29.834 4.262.312 3.212-.038Z"
                />
                <path
                  fill="#3899da"
                  d="M12.64 23.358s-7.161-2.613-3.407-7.49c2.334-3.029 8.123-.088 8.734 8.795h-1.566s.088-3.572-2.008-4.44c-2.097-.867-2.276 1.22-1.753 3.135Zm13.874 0s7.16-2.613 3.405-7.49c-2.333-3.029-8.122-.088-8.733 8.795h1.57s-.085-3.572 2.008-4.44c2.093-.867 2.273 1.22 1.75 3.135Zm-3.521 1.306h-6.901a.74.74 0 0 0-.741.74v.003a.74.74 0 0 0 .74.74h6.902a.74.74 0 0 0 .74-.74v-.003a.74.74 0 0 0-.74-.74Z"
                />
                <path
                  fill="#fff"
                  d="m19.613 19.55-.07-.053h.07v.053ZM5.465 40.998h-.07l.07-.057v.057ZM58.92 26.493c-1.056.59-2.65.885-4.785.887-2.133.003-3.728-.293-4.785-.887-1.392-.716-2.09-2.064-2.09-4.044v-4.947c0-1.998.688-3.378 2.06-4.14 1.019-.589 2.623-.884 4.816-.884 2.13 0 3.725.295 4.785.884 1.37.762 2.056 2.142 2.059 4.14v.03c0 .846-.623 1.265-1.872 1.265-1.25 0-1.91-.42-1.91-1.265v-.03c0-1.706-.213-2.769-.633-3.192-.383-.358-1.196-.537-2.44-.537-1.291 0-2.125.18-2.502.537-.422.465-.635 1.53-.635 3.192v4.95c0 1.436.158 2.392.475 2.876.244.32.59.55.98.647a5.67 5.67 0 0 0 1.681.206c1.37 0 2.26-.293 2.673-.884.2-.305.316-.66.332-1.024.06-.605.087-1.213.08-1.82v-.092c0-.823.637-1.234 1.91-1.234 1.274 0 1.898.411 1.87 1.234v.091c-.006 1.958-.695 3.305-2.069 4.041Zm16.411 0c-1.053.59-2.65.885-4.785.887-2.136.003-3.73-.293-4.781-.887-1.394-.716-2.09-2.064-2.094-4.044 0-2.082 2.293-3.124 6.874-3.127 2.052 0 3.078-.61 3.075-1.832 0-1.706-.212-2.77-.633-3.19-.38-.359-1.194-.538-2.442-.538-1.287 0-2.123.18-2.5.537-.425.464-.635 1.504-.635 3.126v.077c0 .8-.621 1.2-1.867 1.2-1.245 0-1.87-.4-1.871-1.2 0-1.998.686-3.378 2.058-4.14 1.019-.589 2.624-.884 4.816-.884 2.133 0 3.728.295 4.785.884 1.375.762 2.06 2.142 2.059 4.14v4.95c0 1.958-.687 3.305-2.059 4.041Zm-1.71-6.093c-.457.07-.918.112-1.38.125-.508.023-1.074.035-1.696.035-2.09 0-3.135.634-3.135 1.904 0 1.436.157 2.392.474 2.875.245.32.593.55.986.647a5.63 5.63 0 0 0 1.675.206c1.375 0 2.266-.294 2.674-.883.2-.306.317-.66.332-1.025.06-.605.086-1.212.08-1.82l-.01-2.064Zm14.859-6.638c-1.75 0-2.786.073-3.105.22-.846.486-1.267 1.655-1.267 3.508v8.687c0 .802-.623 1.203-1.868 1.203s-1.87-.4-1.87-1.203v-8.675c0-2.255.844-3.709 2.535-4.36a8.874 8.874 0 0 1 2.107-.443 30.926 30.926 0 0 1 3.468-.16.535.535 0 0 1 .604.602c0 .411-.203.62-.604.62v.001Zm10.457 0c-1.755 0-2.79.073-3.106.22-.847.486-1.27 1.655-1.267 3.508v8.687c0 .802-.624 1.203-1.87 1.203-1.25 0-1.87-.4-1.87-1.203v-8.675c0-2.255.846-3.709 2.537-4.36a8.877 8.877 0 0 1 2.104-.443 31.087 31.087 0 0 1 3.472-.16.532.532 0 0 1 .6.602c0 .411-.2.62-.6.62v.001Zm14.002 12.731c-1.076.59-2.672.884-4.785.887-2.194 0-3.8-.296-4.815-.887-1.375-.737-2.061-2.105-2.059-4.106v-4.95c0-1.958.623-3.295 1.868-4.01 1.018-.633 2.687-.949 5.006-.949 2.32 0 3.975.316 4.965.948 1.245.762 1.867 2.1 1.867 4.01 0 2.065-2.281 3.097-6.843 3.097-2.093 0-3.138.622-3.135 1.866-.01.613.033 1.226.126 1.832.047.376.165.74.347 1.073.402.55 1.293.823 2.673.823 1.371 0 2.261-.286 2.674-.853.196-.32.31-.684.332-1.059.06-.603.086-1.21.08-1.816 0-.823.637-1.234 1.91-1.234s1.895.411 1.867 1.234c-.013 1.972-.705 3.337-2.078 4.094Zm-1.791-10.896a2.058 2.058 0 0 0-.332-1.028 1.679 1.679 0 0 0-.966-.647 5.956 5.956 0 0 0-1.696-.206c-1.287 0-2.123.19-2.501.571-.378.38-.634 1.474-.634 3.157v2.057c.467-.069.937-.112 1.409-.13.516-.019 1.092-.03 1.726-.03 2.037 0 3.056-.635 3.056-1.904a17.384 17.384 0 0 0-.062-1.84Zm-.236-10.949-.126.316-2.028 3.066a2.551 2.551 0 0 1-2.292 1.264c-.821 0-1.233-.19-1.233-.567 0-.1.01-.202.03-.3.023-.132.065-.261.126-.382L107.388 5c.462-.823 1.256-1.242 2.375-1.265.802 0 1.203.19 1.203.568a.887.887 0 0 1-.053.327v.02Z"
                />
              </svg>
            </a>
            <p className="fs-sm pb-2 pb-lg-3 mb-3 text-white">
              Invest for the future
            </p>
            <div className="d-flex">
              <a
                className="btn btn-icon btn-sm btn-secondary btn-facebook rounded-circle me-3"
                href="https://www.facebook.com/carre.ai2023"
                aria-label="Facebook"
                target={"_blank"}
                rel="noreferrer"
              >
                <FaFacebook size="20" />
              </a>
              <a
                className="btn btn-icon btn-sm btn-secondary  rounded-circle me-3"
                href="https://www.instagram.com/carre_ai/"
                target={"_blank"}
                rel="noreferrer"
                aria-label="Instagram"
              >
                <FaInstagram size="20" />
              </a>
              <a
                className="btn btn-icon btn-sm btn-secondary  rounded-circle me-3"
                href="https://twitter.com/carre_ai"
                aria-label="Twitter"
                target="_blank"
                rel="noreferrer"
              >
                <FaTwitter size="20" />
              </a>
              <a
                className="btn btn-icon btn-sm btn-secondary  rounded-circle me-3"
                href="https://www.youtube.com/channel/UCQF1qsiCO82aMNOi69GERfw"
                target={"_blank"}
                rel="noreferrer"
                aria-label="youtube"
              >
                <FaYoutube size="20" />
              </a>
              <a
                className="btn btn-icon btn-sm btn-secondary rounded-circle me-3"
                href="https://www.tiktok.com/@carreai"
                target={"_blank"}
                rel="noreferrer"
                aria-label="tiktok"
              >
                <FaTiktok size="20" />
              </a>
            </div>
          </div>
          <div className="col-sm-3 col-lg-2 offset-xl-1 mb-4 mb-sm-0">
            <ul className="nav flex-column">
              {aboutLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href={
                      link.title === "Learn"
                        ? "https://learn.carre.ai/"
                        : link.url
                    }
                    target={link.title === "Learn" ? "_blank" : "_self"}
                    className="text-light fw-semibold text-decoration-none"
                    rel="noreferrer"
                  >
                    {link.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-sm-4 col-lg-2 mb-4 mb-sm-0 ">
            <ul className="nav flex-column">
              <li>
                <a
                  className="nav-link text-white py-1 px-0"
                  href="mailto:info@carre.ai"
                >
                  info@carre.ai
                </a>
              </li>

              <li>
                <a
                  href="https://maps.google.com/?q=370+NE+75th+Street,+Unit+126,+Miami,+Florida,+United+States+33138"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white"
                >
                  370 NE 75th Street, Unit 126, Miami, Florida, United States
                  33138
                </a>
              </li>
            </ul>
          </div>
          <div className="col-sm-5 col-lg-4 col-xl-3 offset-lg-1">
            <h3 className="h6 text-white mb-2">Stay up to date</h3>
            <p className="fs-sm text-white">
              Subscribe to our news and case studies
            </p>
            <Form
              className="mt-4 flex-column align-items-center"
              onSubmit={handleSubmit}
            >
              <div className="input-group input-group-sm">
                <input
                  className="form-control"
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Your email"
                  required
                  aria-label="Email address"
                />
                <div className="input-group-append">
                  <button
                    className="btn btn-primary"
                    type="submit"
                    disabled={isLoading}
                  >
                    {isLoading ? "Subscribing..." : "Subscribe"}
                  </button>
                </div>
              </div>
              <div className="mt-2 form-check">
                <input
                  className="form-check-input bg-white"
                  type="checkbox"
                  id="marketing"
                  name="marketing"
                  aria-label="Receive marketing emails"
                />
                <label
                  className="form-check-label text-white"
                  htmlFor="marketing"
                >
                  Receive marketing emails
                </label>
              </div>
              {isCheckboxError && (
                <div className="text-danger mt-1">
                  Please agree to receive marketing emails to subscribe.
                </div>
              )}
            </Form>
          </div>
        </div>
        <div
          className="container text-white custom-hover "
          onClick={toggleInformation}
        >
          <div className="d-flex justify-content-between align-items-center">
            <p className="text-left mb-2 text-white fs-md">
              <BsFillInfoCircleFill className="me-2" />
              Important Information
            </p>

            {showInformation ? (
              <CiCircleChevUp size="25" className="mb-2" />
            ) : (
              <CiCircleChevDown
                size="25"
                className="mb-4"
                onClick={toggleInformation}
              />
            )}
          </div>

          {showInformation && (
            <>
              <p className="fs-sm opacity-50">
                This information is not an offer to invest in any share, Fund or
                other opportunity and is provided for information only.
                Performance results are shown net of all fees, costs, and
                expenses associated with the share. Should an investor choose to
                redeem a share through Carré or on a secondary market, other
                processing fees may be assessed that are not factored into the
                returns presented. Past performance does not guarantee future
                results. Returns are calculated based on the rental payments
                distributed throughout the year and the appreciation in value of
                the underlying property. The appreciation in value is based on
                the difference between purchase price and annual property
                reappraisals. Individual investor returns may vary based on the
                timing of their investments and redemptions.
              </p>
              <p className="fs-sm opacity-50">
                This site is operated by Carré Inc., which is not a registered
                broker-dealer or investment advisor. Carré Inc. does not give
                investment advice, endorsement, analysis or recommendations with
                respect to any securities. Nothing on this website should be
                construed as an offer to sell, solicitation of an offer to buy
                or a recommendation for any security by Carré Inc. or any third
                party. You are solely responsible for determining whether any
                investment, investment strategy, security or related transaction
                is appropriate for you based on your personal investment
                objectives, financial circumstances and risk tolerance. You
                should consult with licensed legal professionals and investment
                advisors for any legal, tax, insurance or investment advice. All
                securities listed here are being offered by, and all information
                included on this site is the responsibility of, the applicable
                issuer of such securities. Carré Inc. does not guarantee any
                investment performance, outcome or return of capital for any
                investment opportunity posted on this site.
              </p>
              <p className="fs-sm opacity-50">
                By using this website, you agree that Carré may collect certain
                information from you and Carré uses that information to provide
                advertisements about goods and services that are deemed to be of
                greater interest to you. Our{" "}
                <Link className="text-white" to="/privacy-policy">
                  Privacy Policy
                </Link>{" "}
                has more details. By accessing this site and any pages thereof,
                you agree to be bound by the{" "}
                <Link to="/terms-of-service">Terms of Service</Link> and Privacy
                Policy.
              </p>
            </>
          )}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
